var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CloseBtn"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 7",
    d: "M53.4881 17.9073C63.3013 27.7206 63.3013 43.631 53.4881 53.4443C43.6748 63.2575 27.7644 63.2575 17.9511 53.4443C8.13784 43.631 8.13784 27.7206 17.9511 17.9073C27.7644 8.09403 43.6748 8.09404 53.4881 17.9073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.4868 24.0539C48.4037 24.9708 48.4037 26.4575 47.4868 27.3744L41.1657 33.6955C40.072 34.7892 40.072 36.5624 41.1657 37.656L47.4868 43.9771C48.4037 44.8941 48.4037 46.3807 47.4868 47.2977C46.5699 48.2146 45.0832 48.2146 44.1663 47.2977L37.8452 40.9766C36.7515 39.8829 34.9783 39.8829 33.8846 40.9766L27.5635 47.2977C26.6466 48.2146 25.1599 48.2146 24.243 47.2977C23.3261 46.3807 23.3261 44.8941 24.243 43.9771L30.5641 37.656C31.6578 36.5624 31.6578 34.7892 30.5641 33.6955L24.243 27.3744C23.3261 26.4575 23.3261 24.9708 24.243 24.0539C25.1599 23.1369 26.6466 23.1369 27.5635 24.0539L33.8846 30.375C34.9783 31.4686 36.7515 31.4686 37.8452 30.375L44.1663 24.0539C45.0832 23.1369 46.5699 23.1369 47.4868 24.0539Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/CloseBtn.56803de4a845570047ea1e9f793b9629.svg";
export { ForwardRef as ReactComponent };